/* tslint:disable:max-line-length */

import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { APIConfigService } from '../apiconfig.service';

import * as __utils from '../yasag-utils';

import * as __model from '../model';

export interface HelloParams {
  /** List of fields */
  fields?: string;
  /** List of nested objects */
  expand?: string;
}

@Injectable()
export class ImiauthService {
  constructor(
    private http: HttpClient,
    private apiConfigService: APIConfigService) {}


  /** Method to refresh the user last login date. */
  hello(params: HelloParams, multipart = false): Observable<__model.IMIAuthorization> {
    const queryParamBase = {
      fields: params.fields,
      expand: params.expand,
    };

    let queryParams = __utils.getQueryParams(queryParamBase);

    return this.http.get<__model.IMIAuthorization>(this.apiConfigService.options.apiUrl + `/imiauth/hello/`, {params: queryParams});
  }
}
